import React from 'react';
import { NumericFormat } from 'react-number-format';

const CurrencyNumberFormat2 = React.forwardRef(function CurrencyNumberFormat2(props, ref) {
  const { onChange, maxValue, minValue, ...other } = props;
  let minVal = Number(minValue);
  let maxVal = Number(maxValue);

  return (
    <NumericFormat
      {...other}
      getInputRef={ ref }
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          }
        })
      }}
      isAllowed={(values) => {
        const{floatValue} = values;
        let theNumVal = Number(floatValue);
        return theNumVal >=  minVal && theNumVal <= maxVal;
        // const {floatValue} = values;
        // return floatValue >=  minVal && floatValue <= maxVal;
      }}
      valueIsNumericString
      decimalScale={2}
      fixedDecimalScale
      thousandSeparator
      prefix="$"
    />
  );
});

export default CurrencyNumberFormat2;
